export default __webpack_public_path__ + "static/media/text_generation.274f143f.png";